import { render, staticRenderFns } from "./ShortcutMoreModal.vue?vue&type=template&id=46d3586d"
import script from "./ShortcutMoreModal.ts?vue&type=script&lang=ts&external"
export * from "./ShortcutMoreModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports